import { useCallback, useEffect, useRef, useState } from "react";
import socketService from "../services/socketService";
import { useDispatch } from "react-redux";
import { kitchenHandler } from "../redux/handlers";
export function usePosNotificationSocket() {
  const notificationID = useRef(null);
  const dispatch = useDispatch();
  const connect = useCallback(
    (id) => {
      if (!id) return;
      notificationID.current = id;
      if (!socketService.socket) {
        socketService.connect();
      }
      socketService.setNotificationChannel(id);
      console.log("เริ่มต้นการตรวจสอบ Notification จาก server : ", id);

      const updateFromOrderChannel = socketService.registerNotificationHandler((msg) => {
        dispatch(kitchenHandler.handleNotificationSocketResponse(msg));
      });
      return updateFromOrderChannel;
    },
    [dispatch]
  );

  const disconnect = useCallback(() => {
    if (notificationID.current) {
      console.log("Disconnecting from Notification:", notificationID.current);
      notificationID.current = null;
    }
  }, []);

  return { connect, disconnect };
}
